/*
  Algolia-powered predictive search.

  Patches predictive-search-drawer (defined in theme.js) so the dropdown queries Algolia
  instead of Shopify's native /search/suggest.json, while keeping every other behaviour of
  that custom element (loading state, footer, abort handling, "no results" reset button)
  untouched. Only active when settings.algolia_enabled is on.
*/
(function () {
  "use strict";

  var config = window.themeVariables && window.themeVariables.algolia;
  if (!config || !config.enabled || !config.appId || !config.searchApiKey || !config.indexName) {
    return;
  }

  var ENDPOINT = "https://" + config.appId + "-dsn.algolia.net/1/indexes/" + encodeURIComponent(config.indexName) + "/query";
  var HITS_PER_PAGE = 8;

  function formatMoney(amount, format) {
    var settings = window.themeVariables.settings;
    format = format || (settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat);

    var cents = Math.round((amount || 0) * 100);
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? "," : thousands;
      decimal = decimal == null ? "." : decimal;
      number = (number / 100).toFixed(precision);
      var parts = number.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : "";
      return dollars + centsPart;
    }

    var value = "";
    switch (format.match(placeholderRegex)[1]) {
      case "amount":
        value = withDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = withDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = withDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = withDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = withDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = withDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = withDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = withDelimiters(cents, 0, "'");
        break;
    }
    return format.replace(placeholderRegex, value);
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, function (char) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char];
    });
  }

  function dedupeById(hits) {
    var seen = {};
    var result = [];
    for (var i = 0; i < hits.length; i++) {
      var key = hits[i].id;
      if (seen[key]) continue;
      seen[key] = true;
      result.push(hits[i]);
    }
    return result;
  }

  var NAV_ARROW_RIGHT_SVG =
    '<svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-right icon--direction-aware" viewBox="0 0 17 14">' +
    '<path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="' + (window.themeVariables.settings.iconStrokeWidth || 2) + '" fill="none"></path></svg>';

  function renderPriceHtml(hit) {
    var price = hit.variants_min_price != null ? hit.variants_min_price : hit.price;
    var compareAt = hit.variants_compare_at_price_min != null ? hit.variants_compare_at_price_min : hit.compare_at_price;

    if (compareAt && compareAt > price) {
      return (
        '<span class="price price--highlight">' + formatMoney(price) + "</span>" +
        '<span class="price price--compare">' + formatMoney(compareAt) + "</span>"
      );
    }
    return '<span class="price">' + formatMoney(price) + "</span>";
  }

  function renderProductItemHtml(hit, index, queryID) {
    var image = hit.product_image || hit.image;
    if (image) {
      image += (image.indexOf("?") === -1 ? "?" : "&") + "width=210";
    }

    var vendorHtml = window.themeVariables.settings.showVendor && hit.vendor
      ? '<span class="product-item-meta__vendor heading heading--xxsmall">' + escapeHtml(hit.vendor) + "</span>"
      : "";

    var insightsAttrs = queryID
      ? ' data-algolia-click data-algolia-index="' + escapeHtml(config.indexName) + '" data-algolia-query-id="' + escapeHtml(queryID) + '" data-algolia-object-id="' + escapeHtml(hit.objectID) + '" data-algolia-position="' + (index + 1) + '"'
      : "";

    return (
      '<li class="predictive-search__product-item line-item line-item--centered">' +
      '<a href="/products/' + encodeURIComponent(hit.handle) + '" class="line-item__content-wrapper" data-search-product-id="' + escapeHtml(hit.id) + '"' + insightsAttrs + '>' +
      (image ? '<span class="line-item__image-wrapper"><img class="line-item__image" src="' + escapeHtml(image) + '"></span>' : "") +
      '<div class="line-item__info"><div class="product-item-meta">' +
      vendorHtml +
      '<span class="product-item-meta__title text--small">' + escapeHtml(hit.title) + "</span>" +
      '<div class="product-item-meta__price-list-container text--small"><div class="price-list">' + renderPriceHtml(hit) + "</div></div>" +
      "</div></div>" +
      NAV_ARROW_RIGHT_SVG +
      "</a></li>"
    );
  }

  function renderNoResultsHtml() {
    var strings = window.themeVariables.strings;
    return (
      '<p class="text--large">' + escapeHtml(strings.searchNoResults) + "</p>" +
      '<div class="button-wrapper"><button type="button" data-action="reset-search" class="button button--primary">' +
      escapeHtml(strings.searchNewSearch) +
      "</button></div>"
    );
  }

  // --- Empty-input suggestions ("recently searched" + "most popular") ---
  // Products the user opened from search results (drawer, /search page, popular page: all
  // stamp data-search-product-id) are kept in localStorage. When the drawer opens with an
  // empty input we show the last 3, or the top of the popularity replica when there's no
  // history. The /search?view=popular page (algolia-results.js) uses the same data through
  // window.algoliaSearchSuggestions: recents first, then popular products up to the total.
  // All requests use analytics:false so they never show up as "Empty Search" in Algolia.

  var RECENT_STORAGE_KEY = "search_recent_product_ids";
  var RECENT_MAX = 10;
  var DRAWER_SUGGESTIONS_COUNT = 3;
  var POPULAR_INDEX_NAME = config.indexName + "_recently_ordered_count_desc";
  var SUGGESTION_ATTRIBUTES = [
    "id", "title", "handle", "image", "product_image",
    "price", "compare_at_price", "variants_min_price", "variants_compare_at_price_min",
    "vendor", "variants_count", "inventory_available", "meta.custom.sottotitolo"
  ];

  function readRecentIds() {
    try {
      var ids = JSON.parse(localStorage.getItem(RECENT_STORAGE_KEY) || "[]");
      return Array.isArray(ids) ? ids.filter(function (id) { return /^\d+$/.test(String(id)); }) : [];
    } catch (e) {
      return [];
    }
  }

  function rememberRecentId(id) {
    id = String(id);
    if (!/^\d+$/.test(id)) return;
    var ids = readRecentIds().filter(function (existing) { return String(existing) !== id; });
    ids.unshift(id);
    try {
      localStorage.setItem(RECENT_STORAGE_KEY, JSON.stringify(ids.slice(0, RECENT_MAX)));
    } catch (e) {
      // Safari private mode / quota exceeded: no history, the popular fallback still works
    }
  }

  document.addEventListener("click", function (event) {
    var link = event.target instanceof Element ? event.target.closest("[data-search-product-id]") : null;
    if (link) rememberRecentId(link.getAttribute("data-search-product-id"));
  }, true);

  async function queryIndex(indexName, params) {
    var response = await fetch("https://" + config.appId + "-dsn.algolia.net/1/indexes/" + encodeURIComponent(indexName) + "/query", {
      method: "POST",
      headers: {
        "X-Algolia-Application-Id": config.appId,
        "X-Algolia-API-Key": config.searchApiKey,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(Object.assign({
        query: "",
        distinct: true,
        analytics: false,
        clickAnalytics: false,
        attributesToRetrieve: SUGGESTION_ATTRIBUTES,
        attributesToHighlight: [],
        attributesToSnippet: []
      }, params))
    });
    if (!response.ok) {
      throw new Error("Algolia suggestions request failed with status " + response.status);
    }
    var data = await response.json();
    return dedupeById(data.hits || []);
  }

  // Returns { recent: hits, popular: hits } with at most `total` products overall, recents first
  // (most recent first) and popular ones excluding those already in recents. With fill:false
  // popular products are only fetched when there are no recents at all (drawer behaviour).
  async function fetchRecentAndPopular(total, options) {
    var fill = !options || options.fill !== false;
    var recentIds = readRecentIds().slice(0, total);
    var recent = [];

    if (recentIds.length) {
      recent = await queryIndex(config.indexName, {
        filters: recentIds.map(function (id) { return "id=" + id; }).join(" OR "),
        hitsPerPage: recentIds.length
      });
      // Algolia returns them in ranking order: restore "most recent first"
      recent.sort(function (a, b) { return recentIds.indexOf(String(a.id)) - recentIds.indexOf(String(b.id)); });
    }

    var needed = total - recent.length;
    if (needed <= 0 || (!fill && recent.length)) {
      return { recent: recent, popular: [] };
    }

    var recentKeys = recent.map(function (hit) { return String(hit.id); });
    var popular = await queryIndex(POPULAR_INDEX_NAME, { hitsPerPage: needed + recentKeys.length });
    popular = popular.filter(function (hit) { return recentKeys.indexOf(String(hit.id)) === -1; });
    return { recent: recent, popular: popular.slice(0, needed) };
  }

  window.algoliaSearchSuggestions = { fetch: fetchRecentAndPopular };

  function setupSuggestions() {
    var drawer = document.getElementById("search-drawer");
    var block = document.getElementById("predictive-search-suggested-products");
    if (!drawer || !block) return;

    var loaded = false;
    function load() {
      if (loaded || !drawer.hasAttribute("open")) return;
      loaded = true;
      fetchRecentAndPopular(DRAWER_SUGGESTIONS_COUNT, { fill: false }).then(function (result) {
        var isRecent = result.recent.length > 0;
        var hits = isRecent ? result.recent : result.popular;
        if (!hits.length) return;
        block.querySelector(".predictive-search__menu-title").textContent = isRecent
          ? window.themeVariables.strings.searchRecentProducts
          : window.themeVariables.strings.searchPopularProducts;
        block.querySelector(".predictive-search__product-list").innerHTML = hits.map(function (hit, index) {
          return renderProductItemHtml(hit, index, null);
        }).join("");
        block.hidden = false;
      }).catch(function (error) {
        loaded = false;
        console.error(error);
      });
    }

    // Lazy: nothing is requested until the drawer is actually opened
    new MutationObserver(load).observe(drawer, { attributes: true, attributeFilter: ["open"] });
    load();
  }

  async function algoliaSearch(term) {
    var signal = this && this.abortController ? this.abortController.signal : void 0;

    var response = await fetch(ENDPOINT, {
      method: "POST",
      signal: signal,
      headers: {
        "X-Algolia-Application-Id": config.appId,
        "X-Algolia-API-Key": config.searchApiKey,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        query: term,
        hitsPerPage: HITS_PER_PAGE,
        distinct: true,
        clickAnalytics: true,
        attributesToRetrieve: [
          "id", "title", "handle", "image", "product_image",
          "price", "compare_at_price", "variants_min_price", "variants_compare_at_price_min",
          "vendor"
        ]
      })
    });

    if (!response.ok) {
      throw new Error("Algolia predictive search request failed with status " + response.status);
    }

    var data = await response.json();
    var hits = dedupeById(data.hits || []);

    if (window.algoliaInsights) {
      window.algoliaInsights.rememberSearch(config.indexName, data.queryID, hits);
    }

    if (hits.length === 0) {
      return { hasResults: false, html: renderNoResultsHtml() };
    }

    var html =
      '<ul class="predictive-search__product-list list--unstyled" role="list" data-type="products">' +
      hits.map(function (hit, index) { return renderProductItemHtml(hit, index, data.queryID); }).join("") +
      "</ul>";

    return { hasResults: true, html: html };
  }

  function patchPredictiveSearchDrawer() {
    var PredictiveSearchDrawer = window.customElements.get("predictive-search-drawer");
    if (!PredictiveSearchDrawer) {
      return false;
    }
    PredictiveSearchDrawer.prototype._doPredictiveSearch = algoliaSearch;
    PredictiveSearchDrawer.prototype._doLiquidSearch = algoliaSearch;
    return true;
  }

  if (!patchPredictiveSearchDrawer()) {
    document.addEventListener("DOMContentLoaded", patchPredictiveSearchDrawer);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupSuggestions);
  } else {
    setupSuggestions();
  }
})();
